<script>
export default {
  name: 'Spinner',
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    onlyOverlay: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<template>
  <div
    v-show="show"
    class="overlay"
  >
    <div
      v-show="!onlyOverlay"
      class="sk-spinner sk-wave"
    >
      <div class="sk-rect sk-rect1" />
      <div class="sk-rect sk-rect2" />
      <div class="sk-rect sk-rect3" />
      <div class="sk-rect sk-rect4" />
      <div class="sk-rect sk-rect5" />
    </div>
  </div>
</template>
